var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"assetsOfflineList",staticClass:"assets-offline-list"},[_c('assets-offline-map',{ref:"assetsOfflineMap",attrs:{"map-config":_vm.mapConfig,"show-filters":true,"can-import":_vm.canImport,"can-export":true,"fetch-on":"pan","fetch-params":{ status: 'all', include_archived: 1 },"mode":"list"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377c086f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/AssetsOffline/list/index.vue
// module id = null
// module chunks = 